import { useState, useRef, useEffect } from 'react'
// import Image from "next/image"
import { ChevronRight, PlaySquare, ChevronLeft } from 'lucide-react'
// import { Button } from "@/components/ui/button"
import LocalFireDepartmentIcon from '@mui/icons-material/LocalFireDepartment';
import BetBlogIcon from '../../../assets/betblog.png'
const games = [
    {
        id: "1",
        title: "IPL 2025 Teams and Squad Analysis",
        date: "2024-12-16",
        body: 'This article covers all the IPL squads 2025, including retained players lists and the players bought in the Auction. Let’s dive right into the topic.',
    },
    {
        id: "2",
        title: "IPL 2025 Teams and Squad Analysis",
        date: "2024-12-13",
        body: 'This article covers all the IPL squads 2025, including retained players lists and the players bought in the Auction. Let’s dive right into the topic.',
    },
    {
        id: "3",
        title: "IPL 2025 Teams and Squad Analysis",
        date: "2024-12-12",
        body: 'This article covers all the IPL squads 2025, including retained players lists and the players bought in the Auction. Let’s dive right into the topic.',
    },
    {
        id: "4",
        title: "IPL 2025 Teams and Squad Analysis",
        date: "2024-12-03",
        body: 'This article covers all the IPL squads 2025, including retained players lists and the players bought in the Auction. Let’s dive right into the topic.',
    },
    {
        id: "5",
        title: "IPL 2025 Teams and Squad Analysis",
        date: "2024-12-03",
        body: 'This article covers all the IPL squads 2025, including retained players lists and the players bought in the Auction. Let’s dive right into the topic.',
    },
]

export default function BettingBlogCarousel() {
    const [currentIndex, setCurrentIndex] = useState(0)
    const [isAtStart, setIsAtStart] = useState(true)
    const [isAtEnd, setIsAtEnd] = useState(false)
    const carouselRef = useRef(null)

    const nextSlide = () => {
        const newIndex = currentIndex + 1 >= games?.length ? games?.length - 1 : currentIndex + 1
        setCurrentIndex(newIndex)
        setIsAtStart(false)
        setIsAtEnd(newIndex === games?.length - 1)
    }

    const prevSlide = () => {
        const newIndex = currentIndex - 1 < 0 ? 0 : currentIndex - 1
        setCurrentIndex(newIndex)
        setIsAtStart(newIndex === 0)
        setIsAtEnd(false)
    }

    useEffect(() => {
        if (carouselRef.current) {
            carouselRef.current.style.transform = `translateX(-${currentIndex * 210}px)`
        }
    }, [currentIndex])

    return (
        <div className='w-[calc(100vw-20px)] md:max-w-[calc(100vw-130px)]'>
            <div className="max-w-full">
                <div className="flex items-center justify-between mb-4">
                    <div className="flex items-center gap-2">
                        <img src={BetBlogIcon} alt="" />
                        {/* <LocalFireDepartmentIcon className="w-6 h-6 text-yellow-400" /> */}
                        <h2 className="text-xl font-semibold bg-gradient-to-t from-[#009ae5] to-[#46c2ff] bg-clip-text text-transparent">Online Betting Blog</h2>
                    </div>
                    <button className="flex items-center text-sm text-gray-400 hover:text-white transition-colors">
                        All
                        <ChevronRight className="w-4 h-4" />
                    </button>
                </div>

                <div className="relative overflow-auto md:overflow-hidden">
                    <div
                        ref={carouselRef}
                        className="flex transition-transform duration-300 ease-in-out wrapper-article"
                        style={{ width: `${games?.length * 210}px` }}
                    >
                        {games.map((game) => (
                            <div
                                key={game.id}
                                id='cont-div'
                                className="relative group shrink-0 w-[200px] md:w-[38%] mr-4 rounded-lg"
                            >
                                <div className="overflow-hidden rounded-lg px-6 py-[14px] flex flex-col article-bg">
                                    {/* <div className='px-6 py-[14px] flex flex-col article-bg'> */}
                                    <p className='text-[#ffffff99] text-xs font-medium'>{game.date}</p>
                                    <p className='mt-1 font-bold text-white'>{game.title}</p>
                                    <div className='mt-2 text-[#ffffffcc] text-xs'>
                                        <p className='my-3'>{game.body}</p>
                                    </div>
                                    {/* </div> */}
                                </div>
                            </div>
                        ))}
                    </div>
                    <button
                        variant="ghost"
                        size="icon"
                        className="absolute top-1/2 left-2 -translate-y-1/2 disabled:opacity-50 hidden md:block"
                        onClick={prevSlide}
                        disabled={isAtStart}
                    >
                        <ChevronLeft className="w-6 h-6" />
                    </button>
                    <button
                        variant="ghost"
                        size="icon"
                        className="absolute top-1/2 right-2 -translate-y-1/2 disabled:opacity-50 hidden md:block"
                        onClick={nextSlide}
                        disabled={isAtEnd}
                    >
                        <ChevronRight className="w-6 h-6" />
                    </button>
                </div>
            </div>
        </div>
    )
}

